// extracted by mini-css-extract-plugin
module.exports = {"item":"CheckboxList_item__3nnNv","text":"CheckboxList_text__2i9pN"};